<template>
  <div class="app-container">
    <CrudTable entity="Fabric" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import { ProductTypeOption } from '@/utils/constants';

const Labels = {
  Blackout: 'fabric.blackout',
  Pattern: 'fabric.pattern',
  Solid: 'fabric.solid',
  Yes: 'common.yes',
  No: 'common.no'
};

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'domainPrefix',
          label: 'common.domain',
          width: '80px',
          filter: {
            type: 'select',
            options: this.$store.getters.domains,
            valueField: 'id',
            labelField: 'orderNumberPrefix',
            filterName: 'domainID'
          }
        },
        { field: 'domainProductCode', label: 'fabric.domainProductCode' },
        { field: 'description', label: 'fabric.description' },
        {
          field: 'actualWidth',
          label: 'common.fabricWidth',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'yarnNumber',
          label: 'fabric.yarn',
          filter: {
            type: 'select',
            options: this.yarns,
            valueField: 'number',
            labelField: 'number'
          }
        },
        {
          field: 'productTypeDescription',
          label: 'fabric.productType',
          filter: {
            type: 'select',
            options: this.fabricProductTypes,
            valueField: 'description',
            labelField: 'description'
          }
        },
        {
          field: 'fabricStatusOption',
          label: 'fabric.fabricStatusOption',
          formatter: this.formatFabricStatus,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('fabricStatus'),
            valueField: 'code',
            labelField: 'description'
          }
        },
        {
          field: 'hasPatternYN',
          label: 'fabric.pattern',
          formatter: this.formatStaggeredPattern,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Pattern) },
              { value: false, label: this.$t(Labels.Solid) }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        },
        {
          field: 'blackoutYN',
          label: 'fabric.blackout',
          formatter: this.formatBlackout,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Yes) },
              { value: false, label: this.$t(Labels.No) }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        },
        {
          field: 'availableStockInMeters',
          label: 'fabric.availableStock',
          filter: { type: 'none' }
        },
        {
          field: 'createdAt',
          label: 'fabric.createdAt',
          type: 'date',
          filter: { type: 'date' }
        }
      ]
    };
  },
  computed: {
    fabricProductTypes() {
      return this.$store.getters['productType/loadedItems'];
    },
    yarns() {
      return this.$store.getters['yarn/loadedItems'];
    }
  },
  watch: {
    fabricProductTypes(fabricProductTypes) {
      this.getColumn('productTypeDescription').filter.options = fabricProductTypes;
    },
    yarns(yarns) {
      this.getColumn('yarnNumber').filter.options = yarns;
    }
  },
  created() {
    const params = {
      query: {
        productTypeOption: ProductTypeOption.Fabric
      }
    };
    this.$store.dispatch('yarn/getItems');
    this.$store.dispatch('productType/getItems', params);
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary({ description }) {
      return `${description}`;
    },
    formatFabricStatus(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('fabricStatus').find(item => item.code === cellValue);
      return option && option.description;
    },
    formatStaggeredPattern(row, column, cellValue) {
      if (cellValue !== null) {
        return cellValue ? this.$t(Labels.Pattern) : this.$t(Labels.Solid);
      }
      return '';
    },
    formatBlackout(row, column, cellValue) {
      if (cellValue !== null && cellValue) {
        return this.$t(Labels.Blackout);
      }
      return '';
    }
  }
};
</script>
